<ng-container *ngIf="!isPreview">
	<img *ngIf="user.avatar" class="avatar team-avatar" [src]="user.getAvatar()" [style]="'width: ' + avatarSize + 'rem; height: ' + avatarSize + 'rem;'" />
	<span *ngIf="!user.avatar" class="avatar" [style]="'width: ' + avatarSize + 'rem; height: ' + avatarSize + 'rem; line-height: 2; font-size: ' + (avatarSize / 2) + 'rem;'">{{ initials }}</span>
</ng-container>
<ng-container *ngIf="isPreview">
	<div class="avatar preview" [style]="'width: ' + avatarSize + 'rem; height: ' + avatarSize + 'rem; background-image: url(' + user.getPreviewAvatar() + ');'"></div>
</ng-container>
